import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql } from './WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql';

export const DatabaseDownstreamWorkbooksWithoutPersonalSpaceQueryGql: DocumentNode = gql`
query DatabaseDownstreamWorkbooksWithoutPersonalSpaceQuery($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  databases(filter: { id: $databaseId }) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpace
      }
    }
  }
}
${WorkbooksDisplayGridRowDataFragmentWithoutPersonalSpaceGql}
`;
